import React from "react";
import QRCode from "react-qr-code";
import { twoDigitDecimal } from './../../helpers/commonFunction'
import { useSelector } from "react-redux";
import moment from "moment";

const dateFormat = process.env.REACT_APP_DATE_TIME_FORMAT;

const PrintDetail = ({ printDetails, goBack, printType }) => {

  const { defaultCurrency } = useSelector((state) => state.auth);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="print-page">
      <div className="print-container" id="print-receipt">
        {/* Header */}
        <div className="print-header">
          <div>
            <h1>Colt Wireless</h1>
            <p>Transaction Receipt</p>
          </div>

          <div className="receipt-title">
            <span>{printDetails?.ReceiptType || "Receipt"}</span>
            <small>Transaction Receipt</small>
          </div>
        </div>

        {/* Transaction Details */}
        <PrintSection title="Transaction Details">
          <PrintRow
            label1="Txn ID"
            value1={printDetails?.TransactionId}
            label2="Txn Type"
            value2={printDetails?.TXNTYPE || printDetails?.TxnType}
          />

          <PrintRow
            label1="Txn Date"
            value1={moment(printDetails?.TxnDate).format(dateFormat)}
            label2="Payment Date"
            value2={moment(printDetails?.PaymentDate).format(dateFormat)}
          />

          <PrintRow
            label1="Receipt Type"
            value1={printDetails?.ReceiptType}
            label2="Regulatory"
            value2={twoDigitDecimal(printDetails?.Regulatery)}
          />
        </PrintSection>

        {/* Customer / SIM Details */}
        <PrintSection title="Customer & SIM Details">
          <PrintRow
            label1="MSISDN"
            value1={printDetails?.MSISDN}
            label2="SIM Number"
            value2={printDetails?.SimNumber}
          />

          {printType == 1 && <PrintRow
            label1="QR Code"
            value1={
              printDetails?.ESimQRCode ? (
                <div className="print-qr-code text-center">
                  <QRCode value={printDetails?.ESimQRCode} size={80} />
                </div>
              ) : (
                ""
              )
            }
            label2={printType == 1 ? "LPA" : ""}
            value2={printType == 1 ? printDetails?.ESimQRCode : ""}
          />}

          {/* {printType == 1 && <PrintRow
            label1="LPA"
            value1={printDetails?.ESimQRCode}
            lpaFlag={true}
          />} */}
        </PrintSection>

        {/* Plan Details */}
        <PrintSection title="Plan Details">
          <PrintRow
            label1="Name"
            value1={printDetails?.PlanName}
            label2="Description"
            value2={printDetails?.PlanDesc}
          />

          <PrintRow
            label1="Validity"
            value1={printDetails?.Month ? `${printDetails.Month} Month` : "-"}
            label2="Amount"
            value2={`${defaultCurrency}${twoDigitDecimal(printDetails?.PlanAmount)}`}
          />
        </PrintSection>

        {/* Payment Details */}
        {/* <PrintSection title="Payment Details">
          <PrintRow
            label1="Amount"
            value1={`${defaultCurrency}${twoDigitDecimal(printDetails?.PlanAmount)}`}
            label2="Charged Amount"
            value2={`${defaultCurrency}${twoDigitDecimal(printDetails?.ChargedAmount)}`}
          />
        </PrintSection> */}

        {/* Total */}
        <div className="total-section">
          <span>Total Amount Paid</span>
          <strong>{`${defaultCurrency}${twoDigitDecimal(printDetails?.ChargedAmount)}`}</strong>
        </div>

        {/* Footer */}
        <div className="print-footer">
          <p>This is a system generated receipt.</p>
          <span>No signature is required.</span>
        </div>

        {/* Buttons */}
        <div className="print-actions no-print">
          <button
            type="button"
            className="print-btn"
            onClick={handlePrint}
          >
            <i className="ri-printer-line" />
            Print
          </button>

          <button
            type="button"
            className="back-btn"
            onClick={() => goBack()}
          >
            <i className="ri-arrow-left-line" />
            Back
          </button>
        </div>

      </div>
    </div>
  );
};

const PrintSection = ({ title, children }) => {
  return (
    <div className="print-section">
      <div className="section-title">
        {title}
      </div>

      <table className="details-table">
        <tbody>
          {children}
        </tbody>
      </table>
    </div>
  );
};

const PrintRow = ({
  label1,
  value1,
  label2,
  value2,
  lpaFlag = false
}) => {
  return (
    <tr>
      <th>{label1}</th>
      <td colSpan={lpaFlag ? 3 : 1}>{value1 || ""}</td>
      {!lpaFlag && <>
        <th>{label2}</th>
        <td>{value2 || ""}</td>
      </>}
    </tr>
  );
};

export default PrintDetail;